import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, FormControlLabel, Step, StepButton, StepContent, StepLabel, Stepper, Switch} from '@mui/material';
import JHApi from "../../utils/JHApi"
import AdminJHApi from "../../utils/AdminJHApi"
import { PersonalJourneyClasses } from '../../styles/PersonalJourneyClasses';
import { dateAsString, PESONAL_JOURNEY_STEPS } from '../../utils/utils';
import { CoverLetterStep, CVStep, ExcludeDetailsStep, PersonalJourneyExplainNew, TestEmailStep, TitleDetailsStep } from './PersonalJourneySteps';
import { PublishStep } from './PublishStep';
//import Projects from './personalJourney/Projects';
import FieldWithEdit from '../FieldWithEdit';
//import UpcomingMeeting from './personalJourney/UpcomingMeeting';

/*function StepsButton(props) {
    const classes = PersonalJourneyClasses(); 

    const currentStep = props.currentStep || 0

    return (
        <>
            <Button className={classes.backStepButton} disabled={props.isLoading || (props.showedStep === 0)} onClick={props.handleBackStep} variant="outlined" color="primary" size="small" aria-label="Back">Back</Button>
            <Button className={classes.nextStepButton} disabled={props.isLoading || (props.showedStep === 5) || (currentStep === 4 && props.showedStep === 4)} onClick={props.handleNextStep} variant="contained" color="primary" size="small" aria-label="Next Step">Next Step</Button>
        </>
    )
}*/

export function NewJourney(props) {
    const isAdmin = props.isAdmin
    const userId = props.userId
    const isActiveJHUser = props.isActiveJHUser || isAdmin
    const autoRefreshList = props.autoRefreshList

    const [showedStep, setShowedStep] = useState(0);
    const [journeyData, setJourneyData] = useState({});
    const [explenations, setExplenations] = useState({});
    const [extraData, setExtraData] = useState({});
    //const [resumes, setResumes] = useState([]);
    const [isLoadingAll, setIsLoadingAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [sendCVFromDate, setSendCVFromDate] = useState();
    //const [upcomingMeeting, setUpcomingMeeting] = useState();
    //const [isError, setIsError] = useState(false);

    const [uplaodMessage, setUplaodMessage] = useState('');

    //const sawExplenations = journeyData.sawExplenations || {}

    useEffect(() => {
        let paramsToPass = {getExplanations : true}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoadingAll(true)

        JHApi.getPersonalJourneyData(paramsToPass,(response)=>{
            if(response){
                setJourneyData(response.personaljourney);
                if (response.cycles || response.publishData || response.upcomingPublish){
                    setExtraData({cycles:response.cycles||[], publishData:response.publishData||{}, upcomingPublish:response.upcomingPublish})
                }

                setSendCVFromDate(response.sendCVFromDate)

                if (response.explenations){
                    setExplenations(response.explenations)
                }
                /*if (response.upcomingMeeting){
                    setUpcomingMeeting(response.upcomingMeeting)
                }*/
                setShowedStep(response.personaljourney.currentStep)
            } else {
                setJourneyData({});
                setExtraData({})
                setExplenations({})
                setShowedStep(0)
            }

            setIsLoadingAll(false)
        }, (error) => {
            if(error && error.response&& error.response.data&& error.response.data.error){
                console.log(error.response.data.error)     
            } else {
                console.log('Something went wrong')
            }
            setJourneyData({});
            setExtraData({})
            setExplenations({})
            setShowedStep(0)

            setIsLoadingAll(false)
            //setIsError(true)
        })
    }, [isAdmin, userId]);

    const handleStep = step => {
        setShowedStep(step)
    }

    const handleSaveData = (data, onSuccess, onError) => {
        let paramsToPass = {data}

        if (isAdmin){
            paramsToPass.userId = userId
        }
    
        setIsLoading(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            if(response.setStep){
                setShowedStep(response.personaljourney.currentStep)
            }
            if (onSuccess){
                onSuccess(response)
            }
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
            if (onError){
                onError(error)
            }
        })
    }

    const uploadPublishCVFile = event => {
        const maxUploadResumeSize = 50 * 1024; // 50 KB
        const file = event.target.files[0];

        if (!file) {
            return null
        }

        if(file.size > maxUploadResumeSize){
            setUplaodMessage('File too big - 50 KB Max')
            return null
        }
        
        const extension =  file.name.split('.').pop();
        if(!extension.match(/docx|pdf/ig)){
            setUplaodMessage('Invalid extension')
            return null
        }

        setIsLoading(true)
        setUplaodMessage('Uploading...')

        const data = new FormData()
        data.append('file', file, file.name)

        if (isAdmin){
            data.append('userId', userId)
        }

        JHApi.uploadPublishCVFile(data, (response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            setUplaodMessage('')
        }, (error)=>{
            setIsLoading(false)
            setUplaodMessage(error)
        });
    }

    const converToDocx = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.convertGoogleDocsToDocx(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Convert Completed', 
                `Check the file, if incorect:
                1. Open CV on Google docs
                2. Select and copy all content of file (Ctrl + A, then Ctrl + C)
                3. Open new Word file, paste the content (Ctrl + V) 
                4. Save as Word file (.docx)
                5. Upload Word file here`, true)
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            props.showMessageDialog('Convert Failed', 
                `Check the file, if incorect:
                - Validate that the file is Google docs
                - Validate is shared with everyone
                If none of this help:
                1. Open CV on Google docs
                2. Select and copy all content of file (Ctrl + A, then Ctrl + C)
                3. Open new Word file, paste the content (Ctrl + V) 
                4. Save as Word file (.docx)
                5. Upload Word file here`, true)
            
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const converToPdf = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.convertGoogleDocsToPdf(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Convert Completed', `Check the file`)
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            props.showMessageDialog('Convert Failed', 
                `Check the file, if incorect:
                - Validate that the file is Google docs
                - Validate is shared with everyone`)
            
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const sendTest = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.sendPersonalJourneyTest(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
            props.showMessageDialog('Email sent', 'Test sent to email, please check your inbox')
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const startPublish = (beginPublish) => {
        let paramsToPass = {beginPublish}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.startPersonalJourneyPublish(paramsToPass,(response)=>{
            updateDataByRespone(response)
            setIsLoading(false)
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
        })
    }

    const updatePublish = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.updatePersonalJourneyPublish(paramsToPass,(response)=>{
            setJourneyData(response.personaljourney);
            setIsLoading(false)
        }, (error) => {
            if(error && error.response&& error.response.data){
                props.showMessageDialog('Error', error.response.data)
            } else {
                props.showMessageDialog('Error', 'Something went wrong')
            }
            
            setIsLoading(false)
        })
    }

    const handleNextStep = () => {
        if (showedStep === journeyData.currentStep && showedStep<=5){
            let paramsToPass = {}

            if (isAdmin){
                paramsToPass.userId = userId
            }

            setIsLoading(true)

            JHApi.finishPersonalJourneyStep(paramsToPass,(response)=>{
                setJourneyData(response.personaljourney);
                setIsLoading(false)
                setShowedStep(response.personaljourney.currentStep)
            }, (error) => {
                if(error && error.response&& error.response.data && error.response.data.error){
                    props.showMessageDialog('Error', error.response.data.error)
                } else {
                    props.showMessageDialog('Error', 'Something went wrong')
                }
                
                setIsLoading(false)
            })
        } else {
            setShowedStep(showedStep+1)
        }
    }

    /*const handleAddResume = () => {
        let paramsToPass = {}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.addResume(paramsToPass,(response)=>{
            setResumes(response.resumes)
            setIsLoading(false)
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
        })
    }

    const handleUpdateResume = params => {
        let paramsToPass = params

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        JHApi.updateResume(paramsToPass,(response)=>{
            setResumes(response.resumes)
            setIsLoading(false)
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
        })
    }*/

    /*const handleBackStep = () => {
        if (showedStep !== 0){
            setShowedStep(showedStep-1)
        }
    }*/

    const preServerCall = () => {
        setIsLoading(true)
    }

    const postServerCall = (error, response) => {
        if(error){
            props.showMessageDialog('Error', error)
        } else {
            updateDataByRespone(response)
        }

        setIsLoading(false)
    }

    const updateDataByRespone = response => {
        if(response){
            if(response.personaljourney){
                setJourneyData(response.personaljourney);
                if(!response.dontChangeStep){
                    setShowedStep(response.personaljourney.currentStep)
                }
            }
            if (response.cycles || response.publishData || response.upcomingPublish){
                setExtraData({cycles:response.cycles||[], publishData:response.publishData||{}, upcomingPublish:response.upcomingPublish})
            }

            if (response.sendCVFromDate){
                setSendCVFromDate(response.sendCVFromDate)
            }

            if (response.explenations){
                setExplenations(response.explenations)
            }
            /*if (response.upcomingMeeting){
                setUpcomingMeeting(response.upcomingMeeting)
            }*/
            if (autoRefreshList && response.jobHuntClients){
                props.updateHist(response.jobHuntClients, response.jobHuntClients.length)
            }
        }
    }

    const changeSendCVFromDate = newSendCVFromDate => {
        setSendCVFromDate(newSendCVFromDate)
    }

    const changeSafetyNetExpireDate = safetyNetExpireDate => {
        let paramsToPass = {data:{safetyNetExpireDate}}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            postServerCall(null, response)
        }, (error) => {
            console.log(error)
            postServerCall(error)
        })
    }

    const changeCyclesLimit = cyclesLimit => {
        let paramsToPass = {data:{cyclesLimit}}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            postServerCall(null, response)
        }, (error) => {
            console.log(error)
            postServerCall(error)
        })
    }

    const changeIsSendFoundJobEmail = event => {
        let paramsToPass = {data:{isSendFoundJobEmail:event.target.checked}}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            postServerCall(null, response)
        }, (error) => {
            console.log(error)
            postServerCall(error)
        })
    }

    const handleAddToRecruitersList = event => {
        let paramsToPass = {data:{isAddToRecruitersList:event.target.checked, sendCVFromDate}}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)

        AdminJHApi.updatePersonalJourneyDataAdmin(paramsToPass,(response)=>{
            postServerCall(null, response)
        }, (error) => {
            console.log(error)
            postServerCall(error)
        })
    }

    const propsStepsContent = {
        isAdmin,
        journeyData,
        explenations,
        //resumes,
        handleSaveData,
        isLoading,
        userId,
        preServerCall,
        postServerCall,
        converToDocx,
        converToPdf,
        isActiveJHUser
        //handleAddResume,
        //handleUpdateResume
    }

    const classes = PersonalJourneyClasses(); 
    
    const mainStyle = isAdmin?{}:{borderRadius: 2, boxShadow:'0 0 2px rgba(0,0,0,0.2)', backgroundColor: '#fff', marginTop: 16}

    /*
    const isAdmin = props.admin || false
    const userId = props.userId
    const journeyData = props.journeyData || {}
    */
    return (
        <>
        {journeyData._id&&<div style={mainStyle}>
            <div style={{padding:16, paddingBottom:8}}>
                <div style={{position: 'relative'}}>                  
                    {(isAdmin&&journeyData.status==='signed')&&<div>
                        <br/>
                        <FormControlLabel
                            onChange={changeIsSendFoundJobEmail}
                            checked={journeyData.isSendFoundJobEmail||false}
                            control={<Switch color="primary"/>}
                            label="Send 'Found Job' Email"
                            labelPlacement="end"
                            disabled={isLoading}
                        /><br/>
                        <FormControlLabel
                            style={{marginRight: 8}}
                            onChange={handleAddToRecruitersList}
                            checked={journeyData.isAddToRecruitersList||false}
                            control={<Switch color="primary"/>}
                            label="Add to Recruiters List"
                            labelPlacement="end"
                            disabled={isLoading || journeyData.isAddToRecruitersList|| !sendCVFromDate || false}
                        />
                        <strong>from: </strong>
                        <FieldWithEdit value={sendCVFromDate||''} changeValue={changeSendCVFromDate} fieldInputType="date">
                            <span>{sendCVFromDate}</span>
                        </FieldWithEdit>
                        <br/>
                        <strong>Expire safety net date: </strong>
                        <FieldWithEdit value={journeyData.safetyNetExpireDate||''} changeValue={changeSafetyNetExpireDate} fieldInputType="date">
                            <span>{dateAsString(new Date(journeyData.safetyNetExpireDate))||'No expire safety net date'}</span>
                        </FieldWithEdit><br/>
                        <strong>publication limit: </strong>
                        <FieldWithEdit value={journeyData.cyclesLimit||''} changeValue={changeCyclesLimit} fieldInputType="number">
                            <span>{journeyData.cyclesLimit||'No publication limit'}</span>
                        </FieldWithEdit>
                    </div>}
                    {/*<Grid container spacing={1} style={{marginTop:16}}>
                        <Grid item sm={8} xs={12}>
                            <UpcomingMeeting {...propsStepsContent} upcomingMeeting={upcomingMeeting} CSManagers={CSManagers}/>
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <FieldWithEdit value={journeyData.journeyLink||''} changeValue={changeJourneyLink}>
                                {(journeyData.journeyLink)?<a target='_blank' rel="noopener noreferrer" href={journeyData.journeyLink}>Journey Link</a>:
                                <span>No Link</span>}
                            </FieldWithEdit>
                        </Grid>
                    </Grid>*/}
                </div>
            </div>
            {isLoadingAll ? <div style={{textAlign: 'center'}}><CircularProgress/></div>:<>
            {isActiveJHUser&&<>
                    <div style={{display: 'grid'}}>
                    </div>
                        <Stepper className={classes.stepper} nonLinear activeStep={showedStep} orientation="vertical">
                            {PESONAL_JOURNEY_STEPS.map((step, index) => (
                            <Step key={step} disabled={isLoading || (index > journeyData.currentStep)}>
                                <StepButton onClick={() => handleStep(index)}>
                                    <StepLabel>{step} {(index === showedStep)&&<PersonalJourneyExplainNew explenations={explenations} index={index}/>}</StepLabel>
                                </StepButton>
                                <StepContent>
                                    {(index === showedStep && index === 0)&&<TitleDetailsStep {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 1)&&<CoverLetterStep {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 2)&&<CVStep {...propsStepsContent} step={index} uplaodMessage={uplaodMessage} uploadPublishCVFile={uploadPublishCVFile}/>}
                                    {(index === showedStep && index === 3)&&<ExcludeDetailsStep {...propsStepsContent} step={index} updatePublish={updatePublish}/>}
                                    {(index === showedStep && index === 4)&&<TestEmailStep {...propsStepsContent} step={index} sendTest={sendTest} startPublish={startPublish}/>}
                                    {(index === showedStep && index === 5)&&<PublishStep {...propsStepsContent} step={index} updatePublish={updatePublish} cycles={extraData.cycles} upcomingPublish={extraData.upcomingPublish}
                                        publishData={extraData.publishData}/>}

                                    {(journeyData.currentStep===showedStep&&[1,2,3].includes(showedStep))&&<Button disabled={isLoading} variant="contained" color="primary" size="small" onClick={handleNextStep} aria-label="Complete Step">Complete Step</Button>}
                                    {/*(journeyData.currentStep!==0)&&<StepsButton handleBackStep={handleBackStep} handleNextStep={handleNextStep} isLoading={isLoading} showedStep={showedStep} currentStep={journeyData.currentStep}/>*/}
                                    {/*(index === showedStep && index === 0)&&<CoverLetterStep {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 1)&&<TitleStep {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 2)&&<PrePublish {...propsStepsContent} step={index} uplaodMessage={uplaodMessage} uploadPublishCVFile={uploadPublishCVFile} sendTest={sendTest} startPublish={startPublish}/>}
                                    {(index === showedStep && index === 3)&&<PublishStep {...propsStepsContent} step={index} newPublish={newPublish}/>*/}
                                    {/*(index === showedStep && index === 0)&&<FillYourDreamJob {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 1)&&<PutEverythingOnPaper {...propsStepsContent} step={index}/>}
                                    {(index === showedStep && index === 2)&&<CreateCvsAndCoverLetters {...propsStepsContent} step={index}/>*/}
                                    {/*{(index === showedStep && index === 3)&&<Linkedin {...propsStepsContent} step={index}/>}*/}
                                    {/*(index === showedStep && index === 3)&&<PrePublish {...propsStepsContent} step={index}/>*/}
                                    {/*{(index === showedStep && index === 5)&&<Interviews {...propsStepsContent} step={index}*/}
                                </StepContent>
                            </Step>
                            ))}
                        </Stepper>
                    </>}
                </>}
            {/*tabSelected === 1 && <Interviews userId={userId} isAdmin={isAdmin} personalJourneyId={journeyData._id} showMessageDialog={props.showMessageDialog}/>*/}
        </div>}
        </>
    )
}